import { render, staticRenderFns } from "./MenuAccionTableComponentGlobal.vue?vue&type=template&id=e449577e&scoped=true&"
import script from "./MenuAccionTableComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./MenuAccionTableComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./MenuAccionTableComponentGlobal.vue?vue&type=style&index=0&id=e449577e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e449577e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VMenu,VRow})
